import {roles} from "../../../../../resources/js/plugins/utils";
import {hasSportsBetEnabled} from '~/plugins/config'
const packageId = 'sports-bet'
import {hasPermissionByRouteName} from "../../../../../resources/js/router/permissions";

export const navItems = [
    hasSportsBetEnabled() && hasPermissionByRouteName(`admin.sports-bet`) ? {
        icon: 'mdi-basketball',
        title: 'Sports Bet',
        roles: [roles.ADMIN, roles.MANAGER, roles.SUPERVISOR],
        posRoles: [roles.ADMIN, roles.MANAGER, roles.SUPERVISOR],
        hasChildren: true,
        children: [
            !hasPermissionByRouteName(`admin.${packageId}.dashboard`) ? null : {
                to: {name: `admin.${packageId}.dashboard`},
                title: 'Dashboard',
            },
            !hasPermissionByRouteName(`admin.${packageId}.categories`) ? null : {
                to: {name: `admin.${packageId}.categories`},
                title: 'Categories',
            },
            !hasPermissionByRouteName(`admin.${packageId}.events`) ? null : {
                to: {name: `admin.${packageId}.events`},
                title: 'Events',
            },
            !hasPermissionByRouteName(`admin.${packageId}.matches`) ? null : {
                to: {name: `admin.${packageId}.matches`},
                title: 'Matches',
            },
            !hasPermissionByRouteName(`admin.${packageId}.bets`) ? null : {
                to: {name: `admin.${packageId}.bets`},
                title: 'Bets',
            },
            !hasPermissionByRouteName(`admin.${packageId}.bets`) ? null : {
                to: {name: `admin.${packageId}.bets`, query: {status: 2}},
                title: 'Bets Pending Pay',
            },
            !hasPermissionByRouteName(`admin.${packageId}.default-questions`) ? null : {
                to: {name: `admin.${packageId}.default-questions`},
                title: 'Default Questions',
            },
            !hasPermissionByRouteName(`admin.${packageId}.configuration`) ? null : {
                to: {name: `admin.${packageId}.configuration`},
                title: 'Configuration',
            },
            !hasPermissionByRouteName(`admin.${packageId}.results`) ? null : {
                to: {name: `admin.${packageId}.results`},
                title: 'Results',
            },
        ].filter(item => !!item)
    }: null,
].filter(item => !!item)

export const navUserItems = [
    !hasSportsBetEnabled() ? null :{
        icon: 'mdi-basketball',
        title: 'Sports Bet',
        hasChildren: true,
        additionalRoles: (user) => {
            return (
                !!user.enable_sports_bet // Verificando si este usuario puede ver la banca deportiva
            )
        },
        children: [
            !hasPermissionByRouteName(`user.${packageId}.dashboard`) ? null : {
                to: {name: `user.${packageId}.dashboard`},
                title: 'Dashboard',
            },
            !hasPermissionByRouteName(`user.${packageId}.matches`) ? null : {
                to: {name: `user.${packageId}.matches`},
                title: 'Matches',
            },
            !hasPermissionByRouteName(`user.${packageId}.bet-history`) ? null : {
                to: {name: `user.${packageId}.bet-history`},
                title: 'Bets',
            },
        ].filter(item => !!item)
    },
].filter(item => !!item)